<template>
  <div>
    <Header @setScroll="setScroll"></Header>
    <div class="banner">
      <div class="word">
        <div class="wordtitle">
          工业资讯
        </div>
        <div class="smalltitle">
          / Industry Information
        </div>
      </div>
    </div>
    <div class="newList">
      <div id="news">
        <div>
          <div class="list" v-for="(item, index) in PageList" :key="index" @click="toDetails(item.id)">
            <img class="img" :src="baseUrl + item.image">
            <div class="dateinfo">
              <img class="time" src="../../assets/images/time.png">
              <span class="publishTime">{{item.publishTime}}</span>
            </div>
            <div class="contentTitle">
              {{item.contentTitle}}
            </div>
          </div>
        </div>
      </div>
      <Paging @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :currentPage="pageNum"
        :loading="loading" :pageSize="pageSize" :total="total"></Paging>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import Paging from "@/components/common/commonTable";
  import {
    serverUrl
  } from '@/utils/server.js'
  import {
    getArticleData
  } from '@/api/api'
  export default {
    data() {
      return {
        scroll: 'home',
        PageList: [],
        loading: false,
        baseUrl: '',
        pageNum: 0,
        pageSize: 9,
        loading: false,
        total: 0,
      }
    },
    components: {
      Header,
      Footer,
      Paging
    },
    mounted() {
      this.baseUrl = serverUrl.baseURL
      this.getpolicyList()
    },
    methods: {
      toDetails(id) {
        this.$router.push({
          path: "/IndustryDetails",
          query: {
            data: id
          },
        })
      },
      setScroll(eId) {
        this.scroll = eId
      },
      getpolicyList() {
        let params = {
          type: 2,
          page: this.pageNum >= 1 ? this.pageNum - 1 : this.pageNum,
          size: this.pageSize
        }
        getArticleData(params).then(res => {
          this.PageList = res.data.content
          this.total = Number(res.data.totalElements)
        })
      },
      //当前页变更
      handleCurrentChange(num) {
        this.pageNum = num
        this.getpolicyList();
      },
      //当前页查询数据条数变更
      handleSizeChange(num) {
        this.pageSize = num;
        this.pageNum = 1;
        this.currentPage = 1;
        this.getpolicyList();
      },
    }
  }
</script>

<style scoped>
  .banner {
    width: 100%;
    height: 400px;
    background: url(../../assets/images/gyzx@2x.png) top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
  }

  .sidebar {
    width: 1337px;
    margin: 0 auto;
  }

  .newList {
    width: 1373px;
    margin: 40px auto 0;
  }

  .word {
    width: 1337px;
    margin: 100px auto 0;
  }

  .contain {
    overflow-x: hidden;
    font-size: 16px;
    height: 100vh;
    font-family: PingFang-SC-Medium, PingFang-SC !important;
  }

  ::-webkit-scrollbar {
    display: none !important;
    /* Chrome */
  }

  /deep/ .sidebarLeft .el-tabs__active-bar {
    position: absolute;
    top: 0px;
    right: 0;
    height: 20px;
    background: #1E65F2;
    border-radius: 3px;
    z-index: 1;
  }

  .line {
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  #news {
    height: 102%;
    overflow-y: auto;
  }

  #news>div {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap
  }

  .wordtitle {
    font-size: 42px;
    font-family: Source Han Sans CN;
    color: #FFFFFF;
    line-height: 46px;
  }

  .smalltitle {
    font-size: 16px;
    font-family: Adobe Heiti Std;
    color: #FFFFFF;
    line-height: 46px;
  }

  .list {
    box-shadow: 0px 2px 10px 0px rgba(220, 221, 236, 0.5);
    border-radius: 8px;
    width: 396px;
    height: 320px;
    margin: 0 30px 30px;
    cursor: pointer;
  }

  .contentTitle {
    padding: 6px 12px;
    box-sizing: border-box;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 56px;
  }

  .publishTime {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #767D8A;
  }

  .time {
    width: 16px;
    height: 16px;
    margin-right: 5px;
  }

  .img {
    width: 395px;height: 200px;border-radius: 8px;
  }
  
  .dateinfo {
    display: flex;align-items: center;padding: 6px 12px;
  }
</style>



// WEBPACK FOOTER //
// src/views/industry/IndustryList.vue